export const data =[
    {
       question :"What is Reactjs?",
       answer : "React.js is a JavaScript library for building user interfaces."
    },
    {
        question :"What is purpose of Reactjs?",
        answer : "The purpose of React.js is to build user interfaces for web applications with a focus on creating reusable and efficient UI components."
    },
    {
        question :"What is advantage of Reactjs?",
        answer : "Efficient and reusable user interface components for building interactive web applications."
    },
    {
        question :"What is disadvantage of Reactjs?",
        answer : "ReactJS can have a steeper learning curve for beginners."
    },
    {
        question :"Components lifecycle in Reactjs? ",
        answer : "React components go through a lifecycle that includes mounting, updating, and unmounting phases. You can hook into these lifecycle events to perform actions at specific points in a component's existence."
    }
    ]